import VirtualAddressPage from '_components/composed/pages/VirtualAddressPage';
import { NextSeo } from 'next-seo';

export default function VirtualAddress() {
  return (
    <>
      <NextSeo
        title="Virtual Address Service by Incorpified - Establish a Professional Presence"
        description="Establish a professional presence with Incorpified’s Virtual Address service. Perfect for remote businesses needing a reliable business address."
      />
      <VirtualAddressPage />
    </>
  );
}
